import React, { useEffect, useState } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { ReferralItem } from '../../models/referralModel';
import { Option } from '../../../../models/formModel';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  item: ReferralItem | null;
  responsibleOptions: Option[];
  onConfirm: (referralId: string, newResponsibleId: string) => Promise<void>;
  isLoading: boolean;
}

const AssignResponsibleModal: React.FC<Props> = ({
  isOpen,
  toggle,
  item,
  responsibleOptions,
  onConfirm,
  isLoading,
}) => {
  const [selectedId, setSelectedId] = useState<string>('');

  useEffect(() => {
    if (item) {
      setSelectedId(item.assigned_responsible_id || '');
    } else {
      setSelectedId('');
    }
  }, [item, isOpen]);

  if (!item) return null;

  const currentResponsibleName = item.assignedResponsible
    ? `${item.assignedResponsible.first_name || ''} ${item.assignedResponsible.last_name || ''}`.trim()
    : 'Sin asignar';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedId) return;
    await onConfirm(item.id, selectedId);
    toggle();
  };

  const isSameResponsible = selectedId === (item.assigned_responsible_id || '');

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
      <ModalHeader toggle={toggle} className="border-0 pb-0">
        <h4 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '16px' }}>
          Asignar responsable
        </h4>
      </ModalHeader>

      <form onSubmit={handleSubmit}>
        <ModalBody className="py-3">
          <FormGroup className="mb-2">
            <Label style={{ fontSize: '12px', fontWeight: 600, color: '#475569' }}>
              Responsable
            </Label>
            <Input
              type="select"
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              style={{
                fontSize: '13px',
                borderRadius: '6px',
                height: '38px',
                borderColor: '#cbd5e1',
              }}
            >
              <option value="">Seleccionar responsable...</option>
              {responsibleOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {item.assigned_responsible_id && (
            <div className="text-muted" style={{ fontSize: '11px' }}>
              Actual:{' '}
              <span className="font-weight-600 text-dark">
                {currentResponsibleName}
              </span>
            </div>
          )}
        </ModalBody>

        <ModalFooter className="border-0 pt-0">
          <Button
            color="secondary"
            outline
            size="sm"
            onClick={toggle}
            disabled={isLoading}
            style={{ borderRadius: '6px', padding: '6px 14px', fontSize: '12px' }}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            size="sm"
            disabled={isLoading || !selectedId || isSameResponsible}
            style={{
              borderRadius: '6px',
              padding: '6px 18px',
              backgroundColor: '#00c389',
              borderColor: '#00c389',
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '12px',
              boxShadow: '0 2px 6px rgba(0, 195, 137, 0.25)',
            }}
          >
            {isLoading ? 'Guardando...' : 'Guardar'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AssignResponsibleModal;
